/**
 * Composes several functions
 * @return {Function}
 */
export default function compose(...fns) {
  return function (x) {
    return fns.reduceRight((y, f) => f(y), x);
  };
}
